/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Icon from 'material/graphic/icon/icon';
import Link from 'material/ctas/link/link_container';
import DeleteMessage from 'material/message/popup/delete/delete';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/library/reportcard/carddetail/carddetail_styles';



/* ========== ~~~~~~~~~~ REPORTS : LIBRARY : REPORT CARD : CARD DETAIL ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const CardDetail = (props) => (
    <div className={`card-detail ${props.classes.carddetail} ${props.type.toLowerCase()}`}>
        <div className={`detail-label`}><h4>{props.label}</h4></div>
        <div className={`detail-data`}><p>{props.data[props.type] ? props.data[props.type] : 'N/A'}</p></div>
    </div>
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(CardDetail);
